import { newAPI } from 'services';
import qs from 'qs';

export const fetchSellOrdersList = async (userId, establishmentId, page, startDate, endDate, qp) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/store/orders?page=${page}&startDate=${startDate}&endDate=${endDate}${qp}`);
  return response.data;
}

export const fetchSellOrdersResume = async (userId, establishmentId, startDate, endDate, qp) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/store/orders/resume?startDate=${startDate}&endDate=${endDate}${qp}`);
  return response.data;
}

export const fetchSellOrdersExport = async (userId, establishmentId, startDate, endDate, qp) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/store/orders/export?startDate=${startDate}&endDate=${endDate}${qp}`);
  return response.data;
}

export const fetchSellOrder = async (userId, establishmentId, orderId) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/store/orders/${orderId}`);
  return response.data;
}

export const deleteSellOrder = async (userId, establishmentId, orderId, params) => {
  const response = await newAPI.delete(`${userId}/establishment/${establishmentId}/store/orders/${orderId}`, { data: qs.stringify(params) });
  return response.data;
}

export const fetchSellOrderNfe = async (userId, establishmentId, orderId) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/nf/${orderId}/consult`);
  return response.data;
}

export const requestSendNfe = async (userId, establishmentId, orderId) => {
  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/nf/nfe/${orderId}/nfce/send`);
  return response.data;
}